var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../../core/runtime/src';
import { Alert } from '../../../alert/src';
import { Button } from '../../../button/src';
import { Input } from '../../../input/src';
import { FormField } from '../../../form-field/src';
import { Select } from '../../../select/src';
import { Spinner } from '../../../spinner/src';
import { preventDefault } from '../helpers/prevent-default';
// This fake id generation exists due to a bug in Select component
// https://issues.amazon.com/issues/AWSUI-8552
var lastGeneratedId = 0;
var nextGeneratedId = function () { return "awsui-s3-in-context-select-" + lastGeneratedId++; };
export var S3InContext = AwsUi.__addComponent('awsui-s3-in-context', {
    releaseStatus: 'internal',
    properties: {
        loading: {
            type: 'boolean'
        },
        invalid: {
            type: 'boolean'
        },
        uri: {
            type: 'string'
        },
        showVersionSelector: {
            type: 'boolean'
        },
        options: {
            type: 'array',
            itemTypes: ['Select.Option']
        },
        selectedVersionId: {
            type: 'string'
        },
        viewHref: {
            type: 'string'
        },
        alert: {
            type: 'object',
            objectType: 'S3ResourceSelector.Alert'
        },
        inputAriaDescribedby: {
            type: 'string'
        },
        onVersionChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.VersionChange'
        },
        onUriInput: {
            type: 'function',
            functionType: 'S3ResourceSelector.UriInput'
        },
        onUriChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.UriChange'
        },
        onBrowse: {
            type: 'function',
            functionType: 'S3ResourceSelector.Browse'
        },
        onAlertDismiss: {
            type: 'function',
            functionType: 'S3ResourceSelector.AlertDismiss'
        },
        i18nStrings: {
            type: 'object',
            objectType: 'S3ResourceSelector.I18nStrings'
        }
    },
    callbacks: {
        initialized: function () {
            this.__selectControlId = nextGeneratedId();
        }
    },
    render: function () {
        var _a, _b;
        var _c = this, loading = _c.loading, invalid = _c.invalid, uri = _c.uri, showVersionSelector = _c.showVersionSelector, options = _c.options, selectedVersionId = _c.selectedVersionId, viewHref = _c.viewHref, alert = _c.alert, inputAriaDescribedby = _c.inputAriaDescribedby, onAlertDismiss = _c.onAlertDismiss, onVersionChange = _c.onVersionChange, onUriInput = _c.onUriInput, onUriChange = _c.onUriChange, onBrowse = _c.onBrowse, i18nStrings = _c.i18nStrings;
        if (!i18nStrings) {
            return null;
        }
        // to make alert's visibility fully controlled
        var alertDismissPreventDefault = preventDefault(onAlertDismiss);
        var selectedOption = options.filter(function (option) { return option.id === selectedVersionId; })[0];
        var optionsExist = ((_a = options) === null || _a === void 0 ? void 0 : _a.length) > 0;
        return (AwsUi.__createElement("div", { className: "awsui-s3-in-context awsui-util-mb-xs" },
            AwsUi.__createElement("div", { className: "awsui-s3-in-context-fields" },
                AwsUi.__createElement(FormField, { className: "awsui-s3-in-context-fields__uri", stretch: true, label: i18nStrings.inContextUriLabel, control: AwsUi.__createElement(Input, { value: uri, invalid: invalid, autocomplete: false, type: "search", input: onUriInput, change: onUriChange, disabled: false, placeholder: i18nStrings.inContextInputPlaceholder, ariaDescribedby: inputAriaDescribedby }) }),
                showVersionSelector && (AwsUi.__createElement("div", { className: "awsui-s3-in-context-fields__version" },
                    AwsUi.__createElement("label", { class: "awsui-util-label", for: this.__selectControlId, id: this.__selectControlId + "-label" }, i18nStrings.inContextVersionSelectLabel),
                    AwsUi.__createElement(Select, { controlId: this.__selectControlId, options: options, disabled: !optionsExist || loading, selectedOption: selectedOption, selectedLabel: (_b = selectedOption) === null || _b === void 0 ? void 0 : _b.label, placeholder: i18nStrings.inContextSelectPlaceholder, change: onVersionChange, invalid: false }))),
                AwsUi.__createElement("div", null,
                    AwsUi.__createElement(Button, { className: "awsui-s3-in-context-fields__view", disabled: !viewHref, icon: "external", text: i18nStrings.inContextViewButton, href: viewHref, target: "_blank", iconAlign: "right", formAction: "none" })),
                AwsUi.__createElement("div", null,
                    AwsUi.__createElement("span", { className: "awsui-s3-in-context-fields__divider" })),
                AwsUi.__createElement("div", null,
                    AwsUi.__createElement(Button, { className: "awsui-s3-in-context-fields__browse", disabled: loading, text: i18nStrings.inContextBrowseButton, click: onBrowse, formAction: "none" }))),
            AwsUi.__createElement("div", { role: "alert", "aria-live": "assertive", "aria-atomic": "true" }, loading && (AwsUi.__createElement("div", { className: "awsui-s3-in-context__spinner awsui-util-mt-s awsui-util-status-inactive" },
                AwsUi.__createElement(Spinner, { className: "awsui-util-mr-xs" }),
                i18nStrings.inContextLoadingText))),
            AwsUi.__createElement("div", { role: "alert", "aria-live": "assertive", "aria-atomic": "true" }, alert && (AwsUi.__createElement(Alert, __assign({ className: "awsui-s3-in-context__alert awsui-util-mt-l" }, alert, { dismissible: true, dismiss: alertDismissPreventDefault, dismissLabel: i18nStrings.labelAlertDismiss }))))));
    }
});
//# sourceMappingURL=s3-in-context.js.map